module.exports = __webpack_public_path__ + "img/ykbiglogo.33566b7c.png";